(ns frontend.view.settings2.contact-lists.event
  (:require
   [frontend.controller.websocket.event :as ws]
   [frontend.global-events.toast :as toast]
   [frontend.routing :as routing]
   [frontend.view.settings2.contact-lists.sub :as sub]
   [re-frame.core :as rf]))

(rf/reg-event-db
 ::set-edit-mode
 (fn [db [_ edit-mode?]]
   (assoc db ::sub/edit-mode? edit-mode?)))

(rf/reg-event-db
 ::create-contact-list-error
 (fn [db [_ _resp]]
   (js/console.log "create contact list error")
   db))

(rf/reg-event-fx
 ::submit-success
 (fn [{:keys [db]} [_ _label _resp]]
   {:db db}))

(rf/reg-event-fx
 ::submit-error
 (fn [{:keys [db]} [_ _label _resp]]
   (js/console.log "Submit error")
   {:db db}))

(rf/reg-event-fx
 ::create-contact-list-success
 (fn [{:keys [db]} [_ _resp]]
   {:db                   db
    ::toast/success       "Contact list created"
    ::routing/old-routing {:path-args [:settings/contact-lists]}}))

(rf/reg-event-fx
 ::create-contact-list
 (fn [{:keys [db]} [_ data]]
   {:db       db
    ::ws/send {:id         :entity/create-entity
               :body       data
               :on-success [::create-contact-list-success]
               :on-error   [::submit-error "Error creating contact list"]}}))

(rf/reg-event-fx
 ::update-contact-list
 (fn [{:keys [db]} [_ entity-id updates]]
   {:db       db
    ::ws/send {:id         :entity/update-attributes
               :body       {:db/id entity-id
                            :data  updates}
               :on-success [::submit-success "Contact list updated"]
               :on-error   [::submit-error "Error updating contact list"]}}))

(rf/reg-event-fx
 ::submit-form
 (fn [{:keys [_db]} [_ view-mode _data]]
   (let [_event (case view-mode
                  {:id :entity/update-attributes})])))

(rf/reg-event-fx
 ::set-selected-contact-list
 (fn [{:keys [db]} [_ id]]
   {:db                   (assoc db ::sub/selected-contact-list id)
    ::routing/old-routing {:path-args [:settings/contact-list :id id]}}))

(rf/reg-event-fx
 ::open-create-contact-list-view
 (fn [{:keys [db]}]
   (let [id "new-contact-list"
         data {:db/id       id
               :entity/type :entity.type/contact-list}]
     {:db                   (assoc db ::sub/selected-contact-list data)
      ::routing/old-routing {:path-args [:settings/contact-list :id id]}})))

(rf/reg-event-db
 ::set-delete-confirmation-dialog-open
 (fn [db [_ open?]]
   (assoc db ::sub/delete-confirmation-dialog-open? open?)))

(rf/reg-event-fx
 ::disable-contact-list-success
 (fn [{:keys [db]} _]
   {:db                   db
    ::toast/success       "Contact list deleted"
    ::routing/old-routing {:path-args [:settings/contact-lists]}}))

(rf/reg-event-fx
 ::disable-contact-list!
 (fn [{:keys [db]} [_ entity-id]]
   {:db       db
    :fx       [[:dispatch [::set-delete-confirmation-dialog-open false]]]
    ::ws/send {:id         :entity/disable!
               :body       {:entity-id entity-id}
               :on-success [::disable-contact-list-success]
               :on-error   [::submit-error "Error deleting contact list"]}}))
